import styles from '@/styles/chat.module.scss';

/** ScreenOptions — блок кнопок действий текущего экрана. */
export default function ScreenOptions({ children, style }) {
  if (children == null) return null;

  return (
    <div className={styles.options} style={style}>
      {children}
    </div>
  );
}
